import { helpers } from 'vuelidate/lib/validators';

const fullName = (value) => !helpers.req(value) || value.split(' ').length >= 2;

const checkboxRequired = (value) => !helpers.req(value) || value === true;

const maxUploadedFileSizeValidator = (maxFileSize) => (file) => !helpers.req(file) || file.size < maxFileSize;

const mimeTypeUploadedFileValidator = (allowedMimeTypes, allowedFileExtensions) => (file) => !helpers.req(file) || (allowedMimeTypes.includes(file.type) && allowedFileExtensions.includes(`.${file.name.split('.').pop()}`));

export {
  fullName, checkboxRequired, maxUploadedFileSizeValidator, mimeTypeUploadedFileValidator,
};

export default {
  fullName, checkboxRequired, maxUploadedFileSizeValidator, mimeTypeUploadedFileValidator,
};
